<template>
  <main>
    <inncosys-breadcrumbs :history="pathHistory"></inncosys-breadcrumbs>
    <div class="row">
      <div class="col l12 ">
        <div class="row">
          <div class="col l4 input-field">
            <inncosys-sucursales-select v-model="selectedStore" >
            </inncosys-sucursales-select >
          </div>

           <div class="col l2 input-field">
             
             <inncosys-select id="numAnio" v-model="numAnio" :dataSetReady="true" label="Año">
               <option v-for="year in years" v-bind:key="year" >{{year}}</option>
             </inncosys-select>

          </div>
           <div class="col l2 input-field hide-on-small-only">
              <inncosys-select id="numAnio" v-model="numSemana" :dataSetReady="true" label="Semana">
               <option v-for="week in weeks" v-bind:key="week" >{{week}}</option>
             </inncosys-select>
        
            
          </div>
           <div class="col l2 input-field show-on-small hide-on-med-and-up">
            <input placeholder="32" id="numSemana" type="number" class="validate" v-model="numSemana" >
            <label for="numSemana">N° Semana</label>
          </div>
          <div class="col l2 input-field  valign-wrapper">
            <p class="center-align">{{fechaConsultaInicio | dateFilter}}</p>
          </div>
           <div class="col l2 input-field valign-wrapper">
             <p class="center-align">{{fechaConsultaFin | dateFilter}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col l12 s12">
        <div>
           <div v-if="loadingResults" class="progress">
              <div class="indeterminate"></div>
          </div>
          <datatable title="Resultados Indicadores" :columns="columns" :rows="rows" v-on:row-click="openKpiDetails"></datatable>
        </div>
      </div>
    </div>
    <div id="modalDetails" ref="modalDetailsEl" class="modal">
    <div class="modal-content">
      <h4>KPI Detalles</h4>
      <p> Causa, Plan Grafica</p>
    </div>
    <div class="modal-footer">
      <a href="#!" class="modal-close waves-effect waves-green btn-flat">Agree</a>
    </div>
  </div>
  </main>
</template>

<script>
import Breadcrumbs from '../../../components/commun/Breadcrumbs.vue';
import SucursalesSelectName from '../../../components/commun/SucursalesSelectName.vue';
import Select from '../../../components/commun/forms/Select.vue';
import DatePicker from '../../../components/commun/forms/DatePicker.vue';
import DataTable from 'vue-materialize-datatable';
import dateUtils from '../../../utils/date-utils.js';
import * as firebase from 'firebase';
import {indicadorFacturacion} from '../../../controllers/comercial/facturacion.js';

const moment = require('moment');

const facturacionInstance = new indicadorFacturacion();
export default {
  components: {
    inncosysBreadcrumbs: Breadcrumbs,
    inncosysSucursalesSelect: SucursalesSelectName,
    inncosysSelect: Select,
    inncosysDatePicker: DatePicker,
    datatable: DataTable,
  },
  data() {
    return {
      pathHistory: [
        {
          name: 'Inicio',
          route: '/',
        },
        {
          name: 'Tablero Comercial',
          route: '/tablero-comercial/comercial',
        },
      ],
      selectedStore: '',
      fechaConsultaInicio: null,
      fechaConsultaFin: null,
      numSemana: 1,
      numAnio: moment().year(),
      columns: [
        {
          label: 'Nombre', // Column name
          field: 'nombre', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'UM', // Column name
          field: 'um', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Frecuencia', // Column name
          field: 'frecuencia', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'PB', // Column name
          field: 'pb', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Objetivo', // Column name
          field: 'objetivo', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Real', // Column name
          field: 'real', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
      ],
      rows: [],
      employees: [],
      filteredInvoices: [],
      users: {},
      invoices: [],
      loadingResults: false,
      kpis: [],
      kpisMethods: {
        'facturacion-total': this.getInvoices,
      },
      modalDetailsInstace: null,
      invoicesResult: [],
      years:[],
      weeks:[]
    };
  },
  filters: {
    dateFilter(value) {
      if (!value) return '';
      return moment(value).format('DD-MM-YYYY');
    },
  },
  watch: {
    numSemana(value) {
      this.fechaConsultaInicio = moment().year(numAnio)
        .day('Monday')
        .week(value)
        .startOf('day')
        .toDate();
      this.fechaConsultaFin = moment()
        .day('Monday')
        .week(value)
        .startOf('day')
        .add(1, 'week')
        .add(-1, 'second')
        .toDate();
      const vueInstance = this;
      if (
        (this.fechaConsultaInicio != null,
        this.fechaConsultaFin != null && this.selectedStore != null)
      ) {
        this.getAllKpisResults();
      }
    },
    selectedStore(value) {
      if (
        (this.fechaConsultaInicio != null,
        this.fechaConsultaFin != null && this.selectedStore != null)
      ) {
        this.getAllKpisResults();
      }
    },
  },
  methods: {
    convertArrayOfObjectsToCSV(args) {
      let result,
        ctr,
        keys,
        columnDelimiter,
        lineDelimiter,
        data;

      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }

      columnDelimiter = args.columnDelimiter || ',';
      lineDelimiter = args.lineDelimiter || '\n';

      keys = Object.keys(data[0]);

      result = '';
      result += keys.join(columnDelimiter);
      result += lineDelimiter;

      data.forEach((item) => {
        ctr = 0;
        keys.forEach((key) => {
          if (ctr > 0) result += columnDelimiter;

          result += item[key];
          ctr++;
        });
        result += lineDelimiter;
      });

      return result;
    },
    downloadCSV(args) {
      let data,
        filename,
        link;
      let csv = this.convertArrayOfObjectsToCSV({
        data: args.data,
      });
      if (csv == null) return;

      filename = args.filename || 'export.csv';

      if (!csv.match(/^data:text\/csv/i)) {
        csv = `data:text/csv;charset=utf-8,${csv}`;
      }
      data = encodeURI(csv);

      link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', filename);
      link.click();
    },
    openKpiDetails(row) {
      console.log('row clicked', row);
      this.downloadCSV({ filename: 'stock-data.csv', data: row.invoices });
      // this.modalDetailsInstace.open();
    },
    getAllKpisResults() {
      this.kpis.forEach((kpi) => {
        console.log(dateUtils);
        this.kpisMethods[kpi.id](
          this.selectedStore,
          this.fechaConsultaInicio.getTime(),
          this.fechaConsultaFin.getTime(),
          kpi,
        );
      });
    },
    calculateInvoicesAmmount(sucursal, fechaIniMillis, fechaFinMillis, kpi) {
      const fechaIniPB = moment(fechaIniMillis)
        .add(-1, kpi.pb)
        .valueOf();
      const fechaFinPB = moment(fechaFinMillis)
        .add(-1, kpi.pb)
        .valueOf();
      console.log(
        'about to calculate totals',
        sucursal,
        fechaIniMillis,
        fechaFinMillis,
        fechaIniPB,
        fechaFinPB,
        kpi,
      );
      const vueInstance = this;
      facturacionInstance
        .calculateInvoicesDetailedAmmount(
          sucursal,
          fechaIniMillis,
          fechaFinMillis,
        )
        .then((resultReal) => {
          console.log(resultReal);
          facturacionInstance
            .calculateInvoicesDetailedAmmount(
              sucursal,
              fechaIniPB.valueOf(),
              fechaFinPB.valueOf(),
            )
            .then((resultPB) => {
              if (!resultPB.hashMapCountResult.paid) { resultPB.hashMapCountResult.paid = 0; }
              if (!resultReal.hashMapCountResult.paid) { resultReal.hashMapCountResult.paid = 0; }
              vueInstance.rows.push({
                real: resultReal.hashMapCountResult.paid.formatMoney(2),
                nombre: kpi.nombre,
                um: kpi.um,
                frecuencia: kpi.periodo,
                objetivo: 0,
                pb: resultPB.hashMapCountResult.paid.formatMoney(2),
                kpi,
                invoices: resultReal.paidInvoices,
              });
              vueInstance.loadingResults = false;
            });
        });
    },
    getInvoicesData() {
      this.loadingResults = true;
      const vueInstance = this;
      facturacionInstance
        .getInvoicesData()
        .then((invoices) => {
          this.invoices = invoices;
          vueInstance.loadingResults = false;
        })
        .catch((error) => {
          console.log(error);
          this.loadingResults = false;
        });
    },
    getInvoices(sucursal, fechaIni, fechaFin, kpi) {
      this.loadingResults = true;
      this.rows = [];
      if (!(this.invoices.length == 0)) { this.calculateInvoicesAmmount(sucursal, fechaIni, fechaFin, kpi); } else {
        M.toast({
          html:
            'Aun se estan cargando las facturas del sistema, por favor espere',
        });
      }
    },
    getKPIs() {
      const vueInstance = this;
      firebase
        .database()
        .ref('indicadores')
        .orderByChild('monitor')
        .equalTo('comercial')
        .once('value', (snapshot) => {
          snapshot.forEach((indicadorSnapShot) => {
            const kpiObject = indicadorSnapShot.val();
            kpiObject.key = indicadorSnapShot.key;
            vueInstance.kpis.push(kpiObject);
          });
        });
    },
  },
  created() {
     for (var i=moment().year(); i>(moment().year()-5); i--){
      this.years.push(i);
    }
     for (var i=1; i<54; i++){
      this.weeks.push(i);
    }
    this.getKPIs();
    this.getInvoicesData();
   
  },
  mounted() {
    this.numSemana = moment()
      .add(-1, 'week')
      .week();
    this.modalDetailsInstace = M.Modal.init(this.$refs.modalDetailsEl);
  },
};
</script>

<style scoped>
</style>
